import { Static, Type } from '@sinclair/typebox';

export const EmailNotificationMetadataSchema = Type.Object(
  {
    topic: Type.String({ minLength: 1 }),
    dedupe_key: Type.String({ minLength: 1 }),
    reference_type: Type.Optional(Type.String({ minLength: 1 })),
    reference_id: Type.Optional(Type.String({ minLength: 1 })),
    metadata: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
    recipient: Type.String({ minLength: 1 }),
    template: Type.String({ minLength: 1 }),
    subject: Type.String({ minLength: 1 }),
  },
  { additionalProperties: false }
);

export type EmailNotificationMetadata = Static<
  typeof EmailNotificationMetadataSchema
>;

export const UNIVERSAL_REGISTRATION_OTP_EMAIL_KEY =
  'universal-registration-otp' as const;

export const UniversalRegistrationOtpEmailPayloadSchema = Type.Object(
  {
    email: Type.String({ minLength: 1 }),
    template: Type.Literal(UNIVERSAL_REGISTRATION_OTP_EMAIL_KEY),
    requirement: Type.Literal(UNIVERSAL_REGISTRATION_OTP_EMAIL_KEY),
    otp: Type.String({ pattern: '^\\d{6}$' }),
    expires_in_minutes: Type.Integer({ minimum: 1 }),
    otp_expires_at: Type.Integer({ minimum: 1 }),
  },
  { additionalProperties: true }
);

export type UniversalRegistrationOtpEmailPayload = Static<
  typeof UniversalRegistrationOtpEmailPayloadSchema
>;
